type ActionCardProps = {
  icon: React.JSXElementConstructor<{ className: string }>;
  title: string;
  id?: string;
  onClick?: () => void;
};

const ActionCard = ({ icon: Icon, title, onClick, id }: ActionCardProps) => {
  return (
    <div
      id={id}
      onClick={onClick}
      className='bg-surface-subtle border-outline-disabled flex cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border px-6 py-7 shadow-md hover:opacity-65 md:h-68 md:w-60.5 md:gap-6'
    >
      <span className='dark:bg-secondary-50/10 flex h-14 w-14 items-center justify-center rounded-full bg-sky-100'>
        <Icon className='text-primary h-8 w-8' />
      </span>
      <strong className='text-primary text-center text-lg font-medium! md:min-h-12'>{title}</strong>
    </div>
  );
};

export default ActionCard;
